var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAllCx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.4599 55.0001C17.6903 52.5505 12.3463 47.125 10.0093 40.3018",
    stroke: "#059BD2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0425 40.5649C52.659 47.2643 47.3645 52.5846 40.6807 55.0011",
    stroke: "#059BD2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6958 10.1484C47.4602 12.599 52.799 18.0235 55.135 24.8426",
    stroke: "#059BD2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0093 24.8426C12.3442 18.0235 17.6841 12.599 24.4475 10.1484",
    stroke: "#059BD2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.2778 8.72852C40.2778 12.9969 36.8177 16.457 32.5493 16.457C28.2809 16.457 24.8208 12.9969 24.8208 8.72852C24.8208 4.46013 28.2809 1 32.5493 1C36.8177 1 40.2778 4.46013 40.2778 8.72852Z",
    stroke: "#059BD2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.3003 56.4155C40.3003 60.6839 36.8402 64.144 32.5718 64.144C28.3034 64.144 24.8433 60.6839 24.8433 56.4155C24.8433 52.1471 28.3034 48.687 32.5718 48.687C36.8402 48.687 40.3003 52.1471 40.3003 56.4155Z",
    stroke: "#059BD2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.457 32.5723C16.457 36.8407 12.9969 40.3008 8.72852 40.3008C4.46013 40.3008 1 36.8407 1 32.5723C1 28.3039 4.46013 24.8438 8.72852 24.8438C12.9969 24.8438 16.457 28.3039 16.457 32.5723Z",
    stroke: "#059BD2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.1474 40.1971C51.4819 39.5922 48.6865 36.4087 48.6865 32.5718C48.6865 28.3034 52.1467 24.8433 56.415 24.8433C60.6834 24.8433 64.1436 28.3034 64.1436 32.5718C64.1436 36.8402 60.6834 40.3003 56.415 40.3003C55.9836 40.3003 55.5603 40.2652 55.1474 40.1971Z",
    stroke: "#059BD2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.8049 8.35532C34.8049 9.60332 33.7933 10.6149 32.5453 10.6149C31.2973 10.6149 30.2856 9.60332 30.2856 8.35532C30.2856 7.10732 31.2973 6.0957 32.5453 6.0957C33.7933 6.0957 34.8049 7.10732 34.8049 8.35532Z",
    stroke: "#059BD2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4146 14.7288C28.5477 12.5642 30.3459 10.8496 32.5446 10.8496C34.8311 10.8496 36.684 12.7025 36.684 14.9879",
    stroke: "#059BD2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9841 32.1986C10.9841 33.4466 9.97246 34.4582 8.72446 34.4582C7.47646 34.4582 6.46484 33.4466 6.46484 32.1986C6.46484 30.9506 7.47646 29.939 8.72446 29.939C9.97246 29.939 10.9841 30.9506 10.9841 32.1986Z",
    stroke: "#059BD2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M4.59375 38.5726C4.72794 36.4079 6.5251 34.6934 8.72381 34.6934C11.0103 34.6934 12.8632 36.5463 12.8632 38.8317",
    stroke: "#059BD2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.8049 56.0423C34.8049 57.2903 33.7933 58.3019 32.5453 58.3019C31.2973 58.3019 30.2856 57.2903 30.2856 56.0423C30.2856 54.7943 31.2973 53.7827 32.5453 53.7827C33.7933 53.7827 34.8049 54.7943 34.8049 56.0423Z",
    stroke: "#059BD2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4146 62.4158C28.5477 60.2512 30.3459 58.5366 32.5446 58.5366C34.8311 58.5366 36.684 60.3895 36.684 62.6749",
    stroke: "#059BD2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.6711 32.1986C58.6711 33.4466 57.6595 34.4582 56.4115 34.4582C55.1635 34.4582 54.1519 33.4466 54.1519 32.1986C54.1519 30.9506 55.1635 29.939 56.4115 29.939C57.6595 29.939 58.6711 30.9506 58.6711 32.1986Z",
    stroke: "#059BD2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M52.2808 38.5726C52.4139 36.4079 54.2121 34.6934 56.4108 34.6934C58.6973 34.6934 60.5491 36.5463 60.5491 38.8317",
    stroke: "#059BD2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.6706 27.9998C34.6706 29.2478 33.659 30.2595 32.411 30.2595C31.163 30.2595 30.1514 29.2478 30.1514 27.9998C30.1514 26.7518 31.163 25.7402 32.411 25.7402C33.659 25.7402 34.6706 26.7518 34.6706 27.9998Z",
    stroke: "#059BD2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.5492 34.6325C36.5492 32.347 34.6963 30.4941 32.4109 30.4941C30.2122 30.4941 28.414 32.2087 28.2798 34.3734V38.4508H36.5492V34.6325Z",
    stroke: "#059BD2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.4118 29.5594C28.4118 30.8074 27.4002 31.819 26.1522 31.819C24.9042 31.819 23.8926 30.8074 23.8926 29.5594C23.8926 28.3114 24.9042 27.2998 26.1522 27.2998C27.4002 27.2998 28.4118 28.3114 28.4118 29.5594Z",
    stroke: "#059BD2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6687 32.9064C27.9709 32.3716 27.0986 32.0537 26.152 32.0537C23.9533 32.0537 22.1551 33.7683 22.022 35.9329V38.4506H28.2806",
    stroke: "#059BD2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.5259 29.5594C36.5259 30.8074 37.5375 31.819 38.7855 31.819C40.0335 31.819 41.0451 30.8074 41.0451 29.5594C41.0451 28.3114 40.0335 27.2998 38.7855 27.2998C37.5375 27.2998 36.5259 28.3114 36.5259 29.5594Z",
    stroke: "#059BD2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2686 32.9064C36.9664 32.3716 37.8386 32.0537 38.7852 32.0537C40.9839 32.0537 42.7821 33.7683 42.9153 35.9329V38.4506H36.6567",
    stroke: "#059BD2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllCx);
export default __webpack_public_path__ + "static/media/all_cx.7f6fab867cc3fcd1dd949acb323aa3cd.svg";
export { ForwardRef as ReactComponent };